// extracted by mini-css-extract-plugin
export default {"root":"HMNHod_1","trigger":"OpIVctkO","title":"Lmkz5gjm","content":"d0VinMgP"};